import React from 'react'

function Heading({title, subtitle}) {
  return (
    <>
    <div className='heading'>
      <h1>{title}</h1>
      <p style={{color: "#000000" , fontWeight: "900"}}>{subtitle}</p>
    </div>
    </>
  )
}

export default Heading